<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data" class="sea">
      <div class="TopRect">
        <div class="imgs">
          <img :src="data.isPass?'/dive/exam_pass.png':'/dive/exam_failed.png'">
        </div>
        {{ data.examName }}
        <div class="passTag">
          <van-tag v-if="data.isPass" size="large" round :color="GetDiveMainBack()">测试通过</van-tag>
          <van-tag v-if="!data.isPass" size="large" round color="#333">测试未通过</van-tag>
        </div>
        <div class="scoreTitle">本次分数</div>
        <div class="scoreRect">
          <div class="bg rotate" :style="data.isPass?'':'background:none;'" />
          <div class="score">{{ parseInt(data.myScore*100/data.totalScore+0.5) }}</div>
        </div>
      </div>
      <span v-if="data.isPass" class="wave" />
      <span v-if="data.isPass" class="wave" />
      <span v-if="data.isPass" class="wave" />
      <span v-if="!data.isPass" class="waveFailed" />
      <span v-if="!data.isPass" class="waveFailed" />
      <span v-if="!data.isPass" class="waveFailed" />
    </div>
    <div v-if="data" class="buttonRect">
      <van-row v-if="data.type==='TEST'" class="buttons">
        <van-col span="12"><van-button type="primary" round size="small" style="width:calc(100% - 0.5em);" :color="GetColorSecondary()" @click="onErrorList">错题回顾</van-button></van-col>
        <van-col span="12"><van-button type="primary" round size="small" style="width:calc(100% - 0.5em);margin-left:0.5em;" :color="GetDiveMainBack()" @click="onNextUnit">下一单元</van-button></van-col>
      </van-row>
      <van-row v-if="data.type==='EXAM'" class="buttons">
        <van-col span="12"><van-button type="primary" round size="small" style="width:calc(100% - 0.5em);" :color="GetColorSecondary()" @click="onShare">{{ data.isPass?'炫耀一下':'诉苦一下' }}</van-button></van-col>
        <van-col span="12"><van-button type="primary" round size="small" style="width:calc(100% - 0.5em);margin-left:0.5em;" :color="GetDiveMainBack()" @click="onELearn">返回在线学习</van-button></van-col>
      </van-row>
      <van-row v-if="data.type==='Funny'" class="buttons">
        <van-col span="12"><van-button type="primary" round size="small" style="width:calc(100% - 0.5em);" :color="GetColorSecondary()" @click="onShare">炫耀一下</van-button></van-col>
        <van-col span="12"><van-button type="primary" round size="small" style="width:calc(100% - 0.5em);margin-left:0.5em;" :color="GetDiveMainBack()" @click="onTop">排行榜</van-button></van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowFloat, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '测验结果',
      backurl: '/dive',
      studentId: undefined,
      id: undefined,
      data: undefined
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.studentId = getUrlKey('student')
    this.init()
  },
  methods: {
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/DiveLearn/getExamResult',
        method: 'post',
        data: {
          studentId: this.studentId,
          examResultId: this.id
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        // this.data.isPass = false
      })
    },
    onShare() {
      MyNotify('info', '暂未开放')
    },
    onTop() {
      MyNotify('info', '暂未开放')
    },
    onELearn() {
      if (this.studentId && this.studentId !== 'null' && this.studentId !== 'undefined') {
        this.$router.push('/divetrip/eLearn/' + this.studentId)
      } else {
        this.$router.push('/divetrip')
      }
    },
    onErrorList() {
      this.$router.push('/divetrip/examErrorList/' + this.id)
    },
    onNextUnit() {
      console.log('onNextUnit', this.data.next)
      if (!this.data.next) {
        this.onELearn()
        return
      }
      switch (this.data.next.nextType) {
        case 'Video':
          this.$router.push('/divetrip/eVideo/' + this.data.next.nextId + '?student=' + this.studentId)
          break
        case 'Test':
          this.$router.push('/divetrip/exam?examId=' + this.data.next.examId + '&studentId=' + this.studentId)
          break
        case 'Exam':
          break
        case 'Subscribe':
          break
      }
    }
  }
}
</script>
<style scoped>

.sea {
	width:100vw;
	height: calc(100vh - 3em);
	background-color:#fff;
	/* background-image:linear-gradient(
        darkblue,rgba(255,255,255,0) 80%,rgba(255,255,255,0.5)); */
	position: relative;
	overflow:hidden;
}
.sea .TopRect {
	color:#000;
	text-align:center;
	position:absolute;
	z-index:1;
    width:100%;
}
.sea .TopRect .imgs{
    margin:3em 0;
}
.sea .TopRect .imgs img{
    width: 80%;
}
.sea .TopRect .passTag{
    padding: 0.5em 0;
}
.sea .TopRect .scoreTitle{
    color: #999;
    font-size: 0.9em;
}
.sea .TopRect .scoreRect{
    margin-top: 2em;
    position: relative;
}
.sea .TopRect .scoreRect .bg{
    z-index: 1;
    background: url(/dive/light.png) 0px 0px no-repeat;
    background-size: 90vw 90vw;
    width: 90vw;
    height: 90vw;
    left: 90vw;
    margin: -35vw 5vw 0 5vw;
    animation:changDeg 10s linear 0s infinite;
}
.sea .TopRect .scoreRect .score{
    position: absolute;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    line-height: 90vw;
    text-align: center;
    font-weight: 700;
    font-size: 9em;
    z-index: 2;
}
.sea .wave {
	position:absolute;
	top:80vh;
	left:-100vw;
	width:300vw;
	height:300vw;
	background:deepskyblue;
	border-radius:43%;
	filter:opacity(0.4);
	animation:drift linear infinite;
	transform-origin:50% 42%;
}
.sea .waveFailed {
	position:absolute;
	top:80vh;
	left:-100vw;
	width:300vw;
	height:300vw;
	background:#000;
	border-radius:43%;
	filter:opacity(0.2);
	animation:drift linear infinite;
	transform-origin:50% 38%;
}

.sea .wave:nth-of-type(1) {
	animation-duration:5s;
}
.sea .wave:nth-of-type(2) {
    animation-duration:7s;
    background-color:#00AFFF;
}
.sea .wave:nth-of-type(3) {
	animation-duration:9s;
	background-color:orangered;
	filter:opacity(0.1);
}
.sea .waveFailed:nth-of-type(1) {
	animation-duration:5s;
}
.sea .waveFailed:nth-of-type(2) {
    animation-duration:7s;
    background-color:#333;
}
.sea .waveFailed:nth-of-type(3) {
	animation-duration:9s;
	background-color:#000;
	filter:opacity(0.1);
}
.buttonRect{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 4em;
    width: 100%;
}
.buttonRect .buttons{
    padding: 1em 1em;
}
@keyframes drift {
	from {
	transform:rotate(360deg);
}
}
@keyframes changDeg{
0%{
transform: rotate(0deg);
}
100%{
transform: rotate(360deg);
}
}
</style>
